<template>
  <LayoutPage :title="pageTitle" :loading="loading">
    <div class="sticky-container pb-3">
      <div v-if="showRegionFacilitySelectBoxes">
        <RegionAndFacilitySelect over-view-page />
      </div>

      <div></div>
    </div>
    <v-row class="mt-2">
      <v-col>
        <CardHumanBehaviorSummary />
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <CardClimateMonitoring />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="6">
        <CardMoveOutHygieneCompliance />
      </v-col>
      <v-col cols="6">
        <CardOngoingVacantUnitHygiene />
      </v-col>
    </v-row>
  </LayoutPage>
</template>

<script>
import useDashboardTitle from "../useDashboardTitle";
import LayoutPage from "@layout/LayoutPage.vue";
import RegionAndFacilitySelect from "../RegionAndFacilitySelect.vue";
import CardHumanBehaviorSummary from "./CardHumanBehaviorSummary.vue";
import CardClimateMonitoring from "./CardClimateMonitoring.vue";
import CardMoveOutHygieneCompliance from "./CardMoveOutHygieneCompliance.vue";
import CardOngoingVacantUnitHygiene from "./CardOngoingVacantUnitHygiene.vue";

export default {
  components: {
    RegionAndFacilitySelect,
    LayoutPage,
    CardHumanBehaviorSummary,
    CardClimateMonitoring,
    CardMoveOutHygieneCompliance,
    CardOngoingVacantUnitHygiene,
  },
  setup() {
    const pageTitle = useDashboardTitle("Operations & Security Dashboard");
    return { pageTitle };
  },
  data() {
    return {
      loading: false,
      showRegionFacilitySelectBoxes: true,
    };
  },
};
</script>
